/**
 * True if the given profile is the organization owner (permission flag or org creator user).
 *
 * Profiles from `/user-profiles` are prepared without `permissions`, so the creator-user
 * fallback is required for owner checks against other org members.
 *
 * @param {object | null | undefined} candidate - Profile under review
 * @param {object | null | undefined} currentUserOrganization - Current user's org from user store
 * @returns {boolean}
 */
export function profileRepresentsOrganizationOwner(
    candidate,
    currentUserOrganization,
) {
    if (!candidate) {
        return false;
    }

    if (Boolean(candidate.permissions?.owner)) {
        return true;
    }

    const creatorUserId = currentUserOrganization?.creator_user_id;

    return (
        creatorUserId != null &&
        candidate.user_id != null &&
        candidate.user_id == creatorUserId
    );
}
